import React from 'react'
import TopBar from '../bars/top-bar'
import BackIconButton from '../buttons/BackIconButton'
import HeadingBeta from '../headings/heading-beta'
import InfoBlock from '../texts/info-block'

const createTopBarLeftChildren = props => {
  const topBarLeftChildren = [<BackIconButton key='BackIconButton' />]
  return topBarLeftChildren
}

const PrivacyPolicy = props => {
  return (
    <div className='detail-item inner-wrapper-wide'>
      <TopBar
        theme='light-bar'
        leftChildren={createTopBarLeftChildren(props)}
      />
      <HeadingBeta className='bottom-space'>Privacy policy</HeadingBeta>
      <InfoBlock>
        <p>
          Chair-bids does not save nor store any billing information. Billing is
          processed through a 3rd party secure platform.
        </p>
        <p>
          Chair-bids will not share nor store any of your personal information.
        </p>
      </InfoBlock>
    </div>
  )
}

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/ui/views/privacy-policy.js